class TabStopOnCrunchifyCopyLink {
  constructor(options) {
    this.containerSelector = options.containerSelector
    this.linkSelector = options.linkSelector
    this.init()
  }

  init() {
    // Find the container element
    this.container = document.querySelector(this.containerSelector)
    if (!this.container) {
      return
    }

    // Find all link elements within the container
    var links = this.container.querySelectorAll(this.linkSelector)
    this.addAriaRoleToLinks(links)
  }

  addAriaRoleToLinks(links) {
    links.forEach((link) => {
      if (!link.hasAttribute("href")) {
        link.setAttribute("role", "link")
      }
    })
  }
}
export { TabStopOnCrunchifyCopyLink }
